module.exports = "/images/yampi.png?799528aaf90cb4e90167b2ea88c3cf27";